// Module
var code = "<div ng-if=vm.loading layout=column layout-align=\"center center\" layout-fill class=demo-mode><div class=message>Loading...</div></div><div ng-if=!vm.loading layout=column layout-align=\"center center\" layout-fill class=demo-mode><div class=message>Close to stop PrintOS Demo Mode</div></div>";
// Exports
module.exports = code;